import {PMAdSize} from './pm-ad-size.model';
import {PMSite} from './pm-site.model';

export class PMAdUnit {
  adTagId: string;
  adTagName: string;
  adSize: PMAdSize;
  site: PMSite;
  publisherSiteurl: string;
}

